import { NodeSpec } from 'prosemirror-model';
import { Nodes } from '../../constants';
import { Extension } from './Extension';

export class BaseNode extends Extension<NodeSpec> {
  constructor(public readonly name: Nodes) {
    super(name, 'node');
  }
}
